import React from "react";

import deliveryMan from "../../assets/Delivery-Man.jpg";
import classes from "./SecondSection.module.css";

const SecondSection = (props) => {
  return (
    <div className={classes.SecondSection}>
      <div className={classes.Header}>Food Delivery In 45 mins.</div>
      <div
        className={classes.Image}
        style={{ backgroundImage: `url(${deliveryMan})` }}
      ></div>
      <div className={classes.Description}>
        Alo foodie is available now in KANYAKUMARI. The only app you need for
        the quickest doorstep delivery of your favorites.
      </div>
    </div>
  );
};

export default SecondSection;
